module.exports = __webpack_public_path__ + "img/20210701_180126.ea2aea34.jpg";